function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M17.375 8.727a.751.751 0 0 1 1.06.003l2.7 2.705a.8.8 0 0 1 0 1.13l-2.7 2.705a.751.751 0 1 1-1.062-1.06l1.456-1.46H9.45a.75.75 0 1 1 0-1.5h9.38l-1.456-1.46a.75.75 0 0 1 .002-1.063z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M11.98 3.792c-4.516 0-8.184 3.671-8.184 8.208 0 4.537 3.668 8.208 8.184 8.208a8.155 8.155 0 0 0 6.239-2.897c.266-.314.729-.399 1.067-.163.339.237.423.706.16 1.025A9.654 9.654 0 0 1 11.98 21.7c-5.35 0-9.68-4.347-9.68-9.7 0-5.353 4.33-9.7 9.68-9.7a9.652 9.652 0 0 1 7.465 3.526c.263.319.179.788-.16 1.025-.338.236-.8.151-1.067-.163a8.152 8.152 0 0 0-6.238-2.896z"
});

function SvgIconLogOut(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    id: "icon-log-out",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLogOut);
export default __webpack_public_path__ + "static/media/icon-log-out.2924872d.svg";
export { ForwardRef as ReactComponent };